import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, ButtonGroup } from 'reactstrap'
import { roadBookingSetSourceCityOrigin } from '../../../../actions'
import { ROAD_BOOKING_CITY } from '../../../../config/constants'

const RoadBookingSearch = ({ dispatchRoadBookingSetSourceCityOrigin, loading, sourceCityOrigin }) => {

  const handleCityOriginChange = (cityId) => {
    if (loading) return;

    if (sourceCityOrigin === cityId) {
      dispatchRoadBookingSetSourceCityOrigin(null)
      return;
    };

    dispatchRoadBookingSetSourceCityOrigin(cityId);
  }

  return (
    <div>
      {!loading && (
        <ButtonGroup className='modal-fullscreen ' size="lg">
          <Button
            color="primary"
            outline
            onClick={() => handleCityOriginChange(null)}
            active={sourceCityOrigin === null}
          >
            TODOS
          </Button>
          <Button
            color="primary"
            outline
            onClick={() => handleCityOriginChange(ROAD_BOOKING_CITY.BARRANCA.value)}
            active={sourceCityOrigin === ROAD_BOOKING_CITY.BARRANCA.value}
          >
            Barranca
          </Button>
          <Button
            color="primary"
            outline
            onClick={() => handleCityOriginChange(ROAD_BOOKING_CITY.LIMA.value)}
            active={sourceCityOrigin === ROAD_BOOKING_CITY.LIMA.value}
          >
            Lima
          </Button>
        </ButtonGroup>
      )}
    </div>
  )
}
RoadBookingSearch.propTypes = {
  dispatchRoadBookingSetSourceCityOrigin: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  sourceCityOrigin: PropTypes.number.isRequired,
}

const mapStateToProps = ({ BookingUnit }) => ({
  loading: BookingUnit.Booking.getIn(['roadBooking', 'loading']),
  sourceCityOrigin: BookingUnit.Booking.getIn(['roadBooking', 'sourceCityOrigin']),
})


const mapDispatchToProps = {
  dispatchRoadBookingSetSourceCityOrigin: roadBookingSetSourceCityOrigin
}

export default connect(mapStateToProps, mapDispatchToProps)(RoadBookingSearch)
